<template>
  <CChartLine
    :datasets="dataSets"
    :options="options"
    :labels="labels"/>
</template>

<script>
import {CChartLine} from '@coreui/vue-chartjs'
import {getStyle, hexToRgba} from '@coreui/utils/src'

export default {
  name: 'MainChart',
  props: {
    items: Object
  },
  components: {
    CChartLine
  },
  data() {
    return {}
  },
  mounted() {
  },
  computed: {
    dataSets() {
      const brandTotal = getStyle('success') || '#33854f';

      const dataTotal = []
      for (const each of Object.values(this.items)) {
        if (each.total != null) {
          dataTotal.push(each.total);
        }
      }
      return [
        {
          label: 'Tập tin',
          backgroundColor: hexToRgba(brandTotal, 10),
          borderColor: brandTotal,
          pointHoverBackgroundColor: brandTotal,
          borderWidth: 2,
          data: dataTotal
        },
      ]
    },
    labels() {
      return Object.keys(this.items);
    },
    options() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false    // Ẩn/Hiện label
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(250 / 5),
              // max: 250
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 4
          }
        }
      }
    }
  }
}
</script>
